<div class="main">
    <div class="section">
        <div class="header">
            <div class="left">
                <div class="label">
                    {{'PARTIALREGISTRATIONDASHBOARD.title'| translate}}
                </div>
            </div>
            <!-- <div class="right">
                <div class="item">
                    <span class="toggle">{{'PARTIALREGISTRATIONDASHBOARD.Registeredfor' | translate}}</span>
                    <mat-slide-toggle class="switch1">
                    </mat-slide-toggle>
                </div>
            </div> -->
        </div>

        <div class="table">
            <table mat-table [dataSource]="partialregistrationdetails">

                <ng-container matColumnDef="vehicle">
                    <th mat-header-cell *matHeaderCellDef style="text-align: left;">{{'PARTIALREGISTRATIONDASHBOARD.vehicle'|
                        translate}} </th>
                    <td mat-cell *matCellDef="let element;" style="text-align:left;padding-left:25px ">{{element.vehicle}}</td>
                </ng-container>

                <ng-container matColumnDef="driver_name_mobile">
                    <th mat-header-cell *matHeaderCellDef> {{'PARTIALREGISTRATIONDASHBOARD.driver_name_mobile'| translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.driverName}}<br> {{element.mobile}}</td>
                </ng-container>

                <ng-container matColumnDef="registereddate">
                    <th mat-header-cell *matHeaderCellDef> {{'PARTIALREGISTRATIONDASHBOARD.registereddate'| translate}} </th>
                    <td mat-cell *matCellDef="let element">{{element.registeredDate | date : 'dd-MM-yyyy HH:mm a' }}</td>
                </ng-container>

                <ng-container matColumnDef="loadquantity">
                    <th mat-header-cell *matHeaderCellDef> {{'PARTIALREGISTRATIONDASHBOARD.loadquantity'| translate}} </th>
                    <td mat-cell *matCellDef="let element">{{element.load}}</td>
                </ng-container>

                <ng-container matColumnDef="customername_destination">
                    <th mat-header-cell *matHeaderCellDef> {{'PARTIALREGISTRATIONDASHBOARD.customername_destination'| translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.cust_name}} <br> {{element.destination}}</td>
                </ng-container>
                
                <ng-container matColumnDef="material">
                    <th mat-header-cell *matHeaderCellDef> {{'PARTIALREGISTRATIONDASHBOARD.material'| translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.materials}}</td>
                </ng-container>

                <!-- <ng-container matColumnDef="destination">
                    <th mat-header-cell *matHeaderCellDef> {{'PARTIALREGISTRATIONDASHBOARD.destination'| translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.destination}}</td>
                </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="partialregistrationDisplayedColumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row;let i=index; columns: partialregistrationDisplayedColumns">
                </tr>
            </table>
            
        </div>
        <mat-paginator fixed [length]="totalShipments" [pageSize]="50" [pageSizeOptions]="[5,10,25,50,100]" showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator>
    </div>
</div>